import { feedFactoryAxios } from "./feedFactoryAxios";

export const fetchFetchedEntries = async (
  feedId: string,
  page: number,
  searchString: string,
): Promise<any> => {
  const res = await feedFactoryAxios.get(
    `/fetchedentries?feedID=${feedId}&page=${page}&search=${encodeURIComponent(
      searchString,
    )}`,
  );
  return res.data;
};

export const fetchConvertedEntries = async (
  feedId: string,
  page: number,
  searchString: string,
): Promise<any> => {
  const res = await feedFactoryAxios.get(
    `/convertedentries?feedID=${feedId}&page=${page}&search=${encodeURIComponent(
      searchString,
    )}`,
  );
  return res.data;
};
